// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2gVyJ","messages":"Chat_messages__3KxMx","dateDivider":"Chat_dateDivider__2hhgp"};